<template></template>

<script type="text/babel">
import login from "../../assets/js/login";

export default {
    methods: {
        toLogin: function() {
            /*login.hasAuth().then(res => {
                if (!res.data.ok && "999" === res.data.code) {
                    // this.$router.push("/login");
                }

                this.$router.push("/index");
            });*/
            this.$router.push("/index");
        }
    },
    created() {
        this.toLogin();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/login/toLogin.vue